import { render, staticRenderFns } from "./detalle_fisico.vue?vue&type=template&id=289175c4&"
import script from "./detalle_fisico.vue?vue&type=script&lang=ts&"
export * from "./detalle_fisico.vue?vue&type=script&lang=ts&"
import style0 from "./detalle_fisico.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports